export default __webpack_public_path__ + "static/media/YAS0860.34I-38170_-22454_0.1a87bcb4.jpg";